import { baseURL, useGetQuery } from "api/config";

const API = {
  GALLERY_IMAGES: `${baseURL}/api/gallery-images`,
  GALLERY_DESC: `${baseURL}/api/gallery-description`,
};

export const useGalleryImages = () => useGetQuery("GALLERY_IMAGES", API.GALLERY_IMAGES);
export const useGalleryDesc = () => useGetQuery("GALLERY_DESC", API.GALLERY_DESC);
